/** Wishlist-domain WebSocket action constants, grouped so the wishlist worker route handlers and the client-side WS
 * dispatcher branch on a single named map. Spread back into `WS_ACTIONS` so consumers see one flat object.
 *
 * NO PropertyDO wishlist request/reply PAIR: no client handles such a reply, and an unhandled action is a silent
 * no-op, so the round trip would cost a CONVERSATIONS_DB read on every property-detail open for nothing. The wishlist
 * state that surface renders arrives on `wishlistsReceived` over the EXPLORE socket. */

export const WS_WISHLIST_ACTIONS = {
	CREATE_WISHLIST: 'createWishlist',
	ADD_PROPERTY_TO_WISHLIST: 'addPropertyToWishlist',
	REMOVE_PROPERTY_FROM_WISHLIST: 'removePropertyFromWishlist',
	DELETE_WISHLIST: 'deleteWishlist',
	UPDATE_WISHLIST: 'updateWishlist',
	GET_WISHLISTS: 'getWishlists',
	GET_WISHLIST_PROPERTIES: 'getWishlistProperties',
	GET_PROPERTY_WISHLISTS: 'getPropertyWishlists',
	GET_WISHLIST_PARTICIPANTS: 'getWishlistParticipants',
	ADD_WISHLIST_PARTICIPANT: 'addWishlistParticipant',
	REMOVE_WISHLIST_PARTICIPANT: 'removeWishlistParticipant',
	DEFAULT_WISHLIST_CREATED: 'defaultWishlistCreated',
	WISHLIST_CREATED: 'wishlistCreated',
	WISHLIST_DELETED: 'wishlistDeleted',
	WISHLIST_UPDATED: 'wishlistUpdated',
	PROPERTY_ADDED_TO_WISHLIST: 'propertyAddedToWishlist',
	PROPERTY_REMOVED_FROM_WISHLIST: 'propertyRemovedFromWishlist',
	WISHLISTS_RECEIVED: 'wishlistsReceived',
	WISHLIST_PROPERTIES_RECEIVED: 'wishlistPropertiesReceived',
	PROPERTY_WISHLISTS_RECEIVED: 'propertyWishlistsReceived',
	WISHLIST_PARTICIPANTS_RECEIVED: 'wishlistParticipantsReceived',
	WISHLIST_PARTICIPANT_ADDED: 'wishlistParticipantAdded',
	WISHLIST_PARTICIPANT_REMOVED: 'wishlistParticipantRemoved',
} as const;
